<template> <!-- 生成应付账单 -->
  <el-dialog
    :title="$t('receivablePayable.GenerateBillsPayable')"
    width="600px"
    :top="'10vh'"
    :append-to-body="true"
    :visible.sync="isShow"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      v-loading="submitLoading"
      :model="ruleForm"
      :rules="rules"
      size="small"
      label-width="100px"
      class="demo-ruleForm"
      label-position="top"
    >
      <!-- 选择生成应付时间 -->
      <el-form-item :label="$t('receivablePayable.SelectBillingDate')" prop="TimeCollection">
        <el-date-picker
          v-model="ruleForm.TimeCollection"
          style="width: 100%"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('operationCenter.startDate')"
          :end-placeholder="$t('operationCenter.endDate')"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>

      <!-- 账单类型 -->
      <el-form-item :label="$t('collectionCenter.TypeBill')" prop="payableType">
        <el-select
          v-model="ruleForm.payableType"
          :placeholder="$t('GlobalSetObj.pleaseChoose')"
          :disabled="true"
          style="width: 100%"
        >
          <el-option
            v-for="item in PAYABLE_TYPE" :key="item.value" :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 费用类型 DSP-->
      <el-form-item v-if="payableType === 4 || payableType === 7" :label="$t('basicData.ExpenseType')" prop="feeCodeList">
        <el-table
          :data="ruleForm.feeCodeList"
          border
          size="mini"
          max-height="200"
          class="error-table"
        >
          <el-table-column :label="$t('GlobalSetObj.serial')" width="50" type="index" />
          <el-table-column :label="$t('basicData.ExpenseType')">
            <template slot="header">
              <div>
                <span style="color: #f00;margin-right: 5px;">*</span>
                <span>{{ $t('basicData.ExpenseType') }}</span>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="formStyle">
                <el-form-item
                  :prop="'feeCodeList.' + scope.$index + '.feeCode'"
                  :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                >
                  <el-select
                    v-model="scope.row.feeCode"
                    filterable
                    clearable
                    multiple
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    style="width: 100%;"
                    popper-class="top-select"
                    @change="feeTypeChange"
                  >
                    <el-option
                      v-for="item in feeList"
                      :key="item.id"
                      :label="item.displayName"
                      :value="item.code"
                      :disabled="isOptionDisabled(scope.$index, item.code)"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center">
            <template slot="header">
              <span class="el-icon-plus addStyle" @click="addCost" />
            </template>
            <template slot-scope="scope">
              <!--确定删除吗？-->
              <el-popconfirm
                :title="$t('basicData.AreYouSureDelete')"
                @confirm="deleteCost(scope)"
              >
                <span slot="reference" class="el-icon-delete deleteStyle" />
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <!-- 运输业务账单-->
      <template v-if="payableType === 5">
        <el-form-item :label="$t('basicData.PayablePrincipal')">
          <el-select
            v-model="ruleForm.providerId"
            disabled
            style="width: 100%;"
          >
            <el-option
              v-for="item in providerData"
              :key="item.providerId"
              :label="`${item.name}（${item.code}）`"
              :value="item.providerId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('basicData.transportType')">
          <el-select
            v-model="ruleForm.routeType"
            disabled
            style="width: 100%;"
          >
            <el-option
              v-for="item in TRANSPORTATION_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer footer-tips-all">
      <div class="footer-tips-all" style="flex: 1">
        <div class="tips-icon">!</div>
        <div class="tips-text">
          <div>1：{{ $t('receivablePayable.UncheckedDataWillGenerateAccountsPayableForAllQueriedDataConfirmToGenerateAccountsPayable') }}</div>
          <!--网点最多不能超过10个-->
          <div v-if="[1,2,6,7].includes(payableType)">2：{{ $t('receivablePayable.TheNumberOfBranchesCannotExceed10') }}</div>
          <!--网点 + 司机组合最多不能超过30个-->
          <div v-if="[3].includes(payableType)">2：{{ $t('receivablePayable.TheCombinationOfStationsAndDriversCannotExceed30AtMost') }}</div>
          <!--网点最多不能超过5个-->
          <div v-if="[4].includes(payableType)">2：{{ $t('receivablePayable.TheNumberOfBranchesCannotExceed5') }}</div>
          <!--应付主体最多不能超过10个-->
          <div v-if="[5].includes(payableType)">2：{{ $t('receivablePayable.TheMaximumNumberOfPayableEntitiesCannotExceed10') }}</div>
        </div>
      </div>
      <div style="width: 200px;">
        <!--取 消-->
        <el-button
          size="small"
          :disabled="submitLoading"
          @click="onClose"
        >{{ $t('basicData.Cancel') }}</el-button>
        <!--确 定-->
        <el-button
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="submitForm('ruleForm')"
        >{{ $t('basicData.determine') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { PAYABLE_TYPE } from '@/views/finance/enums';
import {
  payableSiteBillPreviewGenerateBillNumberApi,
  payableTransportExpensePreviewGenerateBillNumberApi
} from '@/api/finance/receivables';
import { TRANSPORTATION_TYPE } from '@/views/finance/utils';

export default {
  props: {
    // 多选
    selectData: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 搜索
    queryForm: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 后续处理函数
    cb: {
      type: Function,
      default: () => {
        return () => {};
      }
    },

    // 账单类型
    // 1: 安俊 2: 第三方 3: AJD 4: DSP 5: 运输干支线 6: 邮局配送
    payableType: {
      type: [Number, String],
      required: true
    },

    // 费用类型
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 主体
    providerData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    return {
      PAYABLE_TYPE,
      TRANSPORTATION_TYPE,
      isShow: false,
      submitLoading: false, // 「生成应付」独立 loading，防止重复提交
      feeList: [],
      ruleForm: {
        TimeCollection: [],
        payableType: '',
        feeCodeList: [], // 费用类型
        providerId: '', // 应付主体
        routeType: '' // 路线
      },
      rules: {
        TimeCollection: [
          { required: true, message: this.$t('receivablePayable.TheTimeCannotBeEmpty'), trigger: 'change' }
        ],

        feeCodeList: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ]
      }

    };
  },

  methods: {
    // 关闭
    onClose() {
      this.isShow = false;
      this.ruleForm.TimeCollection = [];
      this.ruleForm.feeCodeList = [];
    },

    /**
     * 打开
     * @description 打开弹窗
     */
    open() {
      this.isShow = true;
      const { params } = this.queryForm;
      this.ruleForm.payableType = this.payableType;
      this.ruleForm.providerId = params.providerId; // 应付主体
      this.ruleForm.routeType = params.routeType; // 路线
      this.feeList = cloneDeep(this.feeTypeOption);
      this.addCost();

      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },

    // 确定
    submitForm(formName) {
      // 请求进行中直接忽略，避免重复生成应付
      if (this.submitLoading) {
        return false;
      }
      // 表单校验
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const row = await this.setData(); // 获取数据
          if (row) {
            this.asyncApiPayableSiteBillGenerateBillNumber(row); // 生成应付账单
          }
        }
      });
    },

    // 数据处理
    async setData() {
      const ids = [];
      const businessTypes = [];
      const paramForm = cloneDeep(this.queryForm.params);
      paramForm.siteType = paramForm.siteType || null;

      // 勾选了使用勾选的数据
      if (this.selectData.length !== 0) {
        businessTypes.push(this.selectData[0].businessType);
        this.selectData.forEach(item => {
          ids.push(item.id);
        });
      }
      // 使用搜索条件的数据
      if (businessTypes.length === 0) {
        businessTypes.push(paramForm.businessType);
      }
      const msg =
        ids.length > 0
          ? this.$t('receivablePayable.AreYouSureToGenerateAccountsPayableForTheSelectedData') // 确定给选中数据生成应付？
          : this.$t('receivablePayable.UncheckedDataWillGenerateAccountsPayableForAllQueriedDataConfirmToGenerateAccountsPayable'); // '未勾选数据将会给查询到的所有数据都生成应付，确定生成应付？';
      try {
        await this.$confirm(msg,
          this.$t('basicData.tips'), // '提示'
          {
            confirmButtonText: this.$i18n.t('basicData.determine'), // '确定',
            cancelButtonText: this.$i18n.t('basicData.Cancel'), // '取消',
            type: 'warning'
          }
        );
        const { TimeCollection, payableType, feeCodeList } = this.ruleForm;
        paramForm.nameStartTime = TimeCollection[0];
        paramForm.nameEndTime = TimeCollection[1];
        paramForm.payableType = payableType;
        if (payableType === 4 || payableType === 7) {
          paramForm.billFeeCodeList = feeCodeList.map(item => item.feeCode);
        }
        const param = {
          ...paramForm,
          businessType: businessTypes[0],
          ids: ids
        };

        // 揽收人
        if (!Array.isArray(param.collectorIdList)) {
          param.collectorIdList = [];
        }

        return param;
      } catch (error) {
        console.error(error);
        return undefined;
      }
    },

    // 确定
    async asyncApiPayableSiteBillGenerateBillNumber(param) {
      const { payableType } = param;
      const API = payableType === 5 ? payableTransportExpensePreviewGenerateBillNumberApi : payableSiteBillPreviewGenerateBillNumberApi;
      this.submitLoading = true;
      try {
        const res = await API(param);
        this.cb(res.data, param);
        this.onClose();
      } catch (err) {
        console.error(err);
      } finally {
        this.submitLoading = false;
      }
    },
    // 删除费用
    deleteCost(scope) {
      this.ruleForm.feeCodeList.splice(scope.$index, 1);
      this.$forceUpdate();
    },
    // 添加费用
    addCost() {
      this.ruleForm.feeCodeList.push({
        feeCode: [] // 费用类型代码
      });
    },
    // 选择费用类型
    feeTypeChange() {
      this.$forceUpdate();
    },
    isOptionDisabled(currentIndex, optionValue) {
      // 如果当前行已经选择了这个选项，不禁用（允许取消选择）
      if (this.ruleForm.feeCodeList[currentIndex].feeCode.includes(optionValue)) {
        return false;
      }

      // 检查此选项是否已被其他行选中
      return this.ruleForm.feeCodeList.some((row, index) =>
        index !== currentIndex &&
        Array.isArray(row.feeCode) &&
        row.feeCode.includes(optionValue)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.error-table  .el-table__body-wrapper {
  overflow: auto !important;
}
.footer-tips-all {
  display: flex;
  align-items: center;
}
.tips-icon {
  width: 25px;
  height: 25px;
  display:flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background:#f1c024;
  color: #fff;
}
.tips-text {
  flex: 1;
  text-align: left;
  margin-left: 10px;
  font-size: 14px;
}
</style>
